import * as ReactQuery from 'react-query';
import { InferMutationOptions, Services } from 'services';
import { Store } from 'store';
import { useIntl } from 'react-intl';
import { update601VisitStatusAPI } from './api';

const UPDATE_601_VISIT_STATUS_KEY = '@referrals/update-601-visit-status';

export function useUpdate601VisitStatus(
  options?: InferMutationOptions<typeof update601VisitStatusAPI>
) {
  const queryClient = ReactQuery.useQueryClient();

  const { showNotification } = Store.useNotifications();

  const intl = useIntl();

  const { mutate, isLoading, isError } = ReactQuery.useMutation(
    UPDATE_601_VISIT_STATUS_KEY,
    update601VisitStatusAPI,
    {
      ...options,
      onSuccess: (variables) => {
        queryClient.setQueriesData(
          [Services.Referrals.KEYS.GET_REFERRAL_KEY, variables.referralId],
          (currentData: any) => ({
            ...currentData,
            isVisit601Completed: variables.visit601Status,
          })
        );
        queryClient.resetQueries([
          Services.Referrals.KEYS.GET_REFERRAL_ACTIVITY_KEY,
          variables.referralId,
        ]);
        showNotification({
          variant: 'success',
          description: intl.formatMessage({
            id: 'server.success.update_referral_601_visit_status',
            defaultMessage: '601 Visit status updated successfully.',
          }),
        });
      },
      onError: (error, data, context) => {
        showNotification({
          variant: 'error',
          description: intl.formatMessage({
            id: 'server.errors.update_referral_601_visit_status',
            defaultMessage:
              "Unfortunately, something failed when updating the patient's 601 visit status. Please, try again.",
          }),
        });

        if (options?.onError) {
          options.onError(error, data, context);
        }
      },
    }
  );

  return {
    update601VisitStatus: mutate,
    isLoading,
    isError,
  };
}
